<template>
    <WordHighlighter :query="query">
        <span>
            <i
                v-if="
                    result['historicky-nazev'].length > 0 ||
                    result['cizojazycny-nazev'].length > 0 ||
                    result['puvod-nazvu-text-tucny'].length > 0 ||
                    result['prehistorie-text-tucny'].length > 0 ||
                    (result['nazev-ulice'].length > 0 &&
                        result['typ-hesla-ulice'] !== 'RUIAN')
                "
                class="font-bold not-italic"
            >
                <i
                    v-if="result['typ-hesla-ulice'] === 'RUIAN'"
                    class="font-bold not-italic"
                >
                    {{ result["nazev-ulice"] + ", " }}
                </i>
                <!--Zaniklá ulice-->
                <i
                    v-else-if="result['typ-hesla-ulice'] === 'Zaniklá'"
                    class="font-bold not-italic"
                >
                    <i
                        v-if="
                            result['historicky-nazev'].length > 0 ||
                            result['cizojazycny-nazev'].length > 0 ||
                            result['puvod-nazvu-text-tucny'].length > 0 ||
                            result['prehistorie-text-tucny'].length > 0
                        "
                        class="font-bold not-italic"
                    >
                        {{ result["nazev-ulice"] + " x" }}
                        <em class="text-[16px] font-normal not-italic">
                            (zaniklá ulice),
                        </em>
                    </i>
                    <i
                        v-else
                        class="font-bold not-italic"
                    >
                        {{ result["nazev-ulice"] + " x" }}
                        <em class="text-[16px] font-normal not-italic">
                            (zaniklá ulice)
                        </em>
                    </i>
                </i>
                <!--Nevzniklá ulice-->
                <i
                    v-else-if="result['typ-hesla-ulice'] === 'Nevzniklá'"
                    class="font-bold not-italic"
                >
                    <i
                        v-if="
                            result['historicky-nazev'].length > 0 ||
                            result['cizojazycny-nazev'].length > 0 ||
                            result['puvod-nazvu-text-tucny'].length > 0 ||
                            result['prehistorie-text-tucny'].length > 0
                        "
                        class="font-bold not-italic"
                    >
                        {{ result["nazev-ulice"] + " ~" }}
                        <em class="text-[16px] font-normal not-italic">
                            (nevzniklá ulice),
                        </em>
                    </i>
                    <i
                        v-else
                        class="font-bold not-italic"
                    >
                        {{ result["nazev-ulice"] + " ~" }}
                        <em class="text-[16px] font-normal not-italic">
                            (nevzniklá ulice)
                        </em>
                    </i>
                </i>
            </i>
            <i
                v-else
                class="font-bold not-italic"
            >
                {{ result["nazev-ulice"] }}
            </i>
        </span>

        <span v-if="result['historicky-nazev'].length > 0">
            <b class="pr-1 font-normal underline">historický název:</b>
            <i
                v-if="
                    result['cizojazycny-nazev'].length > 0 ||
                    result['puvod-nazvu-text-tucny'].length > 0 ||
                    result['prehistorie-text-tucny'].length > 0
                "
                class="not-italic"
            >
                {{ result["historicky-nazev"] + ", " }}
            </i>
            <i
                v-else
                class="not-italic"
            >
                {{ result["historicky-nazev"] }}
            </i>
        </span>

        <span v-if="result['cizojazycny-nazev'].length > 0">
            <b class="pr-1 font-normal underline"> cizojazyčný název:</b>
            <i
                v-if="
                    result['historicky-nazev'].length > 0 ||
                    result['puvod-nazvu-text-tucny'].length > 0 ||
                    result['prehistorie-text-tucny'].length > 0
                "
                class="not-italic"
            >
                {{ result["cizojazycny-nazev"] + ", " }}
            </i>
            <i
                v-else
                class="not-italic"
            >
                {{ result["cizojazycny-nazev"] }}
            </i>
        </span>

        <span v-if="result['puvod-nazvu-text-tucny'].length > 0">
            <b class="pr-1 font-normal underline">původ názvu:</b>
            <i
                v-if="
                    result['historicky-nazev'].length > 0 ||
                    result['cizojazycny-nazev'].length > 0 ||
                    result['prehistorie-text-tucny'].length > 0
                "
                class="not-italic"
            >
                {{ result["puvod-nazvu-text-tucny"] + ", " }}
            </i>
            <i
                v-else
                class="not-italic"
            >
                {{ result["puvod-nazvu-text-tucny"] }}
            </i>
        </span>

        <span v-if="result['prehistorie-text-tucny'].length > 0">
            <b class="pr-1 font-normal underline">prehistorie:</b>
            <i
                v-if="
                    result['historicky-nazev'].length > 0 ||
                    result['cizojazycny-nazev'].length > 0 ||
                    result['puvod-nazvu-text-tucny'].length > 0
                "
                class="not-italic"
            >
                {{ result["prehistorie-text-tucny"] + ", " }}
            </i>
            <i
                v-else
                class="not-italic"
            >
                {{ result["prehistorie-text-tucny"] }}
            </i>
        </span>
    </WordHighlighter>
</template>

<script lang="ts" setup>
import WordHighlighter from "vue-word-highlighter"

interface SearchResult {
    "nazev-ulice": string
    "historicky-nazev": string
    "cizojazycny-nazev": string
    "puvod-nazvu-text-tucny": string
    "prehistorie-text-tucny": string
    "typ-hesla-ulice": string
}

defineProps<{
    result: SearchResult
    query: string
}>()
</script>

<style lang="scss"></style>
